import { render, staticRenderFns } from "./FiscalFoundComponent.vue?vue&type=template&id=8edd7cf6"
import script from "./FiscalFoundComponent.vue?vue&type=script&lang=js"
export * from "./FiscalFoundComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports